import axios from "axios";
import env from "../config/envHelper";

const publicApiClient = axios.create({
    baseURL: env.REACT_APP_BACKEND_URL,
    withCredentials: true,
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
    },
});

export default publicApiClient;